module.exports = __webpack_public_path__ + "static/media/CloseMenu.9fce1951.svg";